import { ReferCookie } from "./refercookie";

declare var gtag: (...args: any[]) => void;

function grantGoogleAnalytics() {
    if (gtag) {
        gtag("consent", "update", {
            "ad_user_data": "granted",
            "ad_personalization": "granted",
            "ad_storage": "granted",
            "analytics_storage": "granted",
            "personalization_storage": "granted",
        });
    }
}

function grantReferCookie() {
    const cook = new ReferCookie();
    cook.saveReferCookie();
    cook.saveTMCookie();
}

const LINK_TERMS =
    "<a class='cc-link' target='_blank' href='/Home/Terms-Of-Use'>Terms of Use</a>";
const LINK_PRIVACY =
    "<a class='cc-link' target='_blank' href='/Home/Privacy-Policy'>Privacy Policy</a>";

// default cookie consent setup
export const COOKIECONSENTSETUP = {
    palette: {
        popup: {
            background: "#1f2350",
        },
        button: {
            background: "#6495ed",
        },
    },

    theme: "classic",
    content: {
        message:
            "This site uses various technologies for personalization and measuring website use/performance, which may include storing and sharing information about your site visit with third parties. By continuing to use this website you consent to our " +
            LINK_TERMS + " and " + LINK_PRIVACY + ".",
        dismiss: "I understand",
        link: "",
        href: "/Home/Privacy-Policy", // Link to your privacy policy
    },
    onInitialise: function (status) {
        if (this.hasConsented()) {
            //grantGoogleAnalytics();
            //grantReferCookie();
        }
    },
    onStatusChange: function (status) {
        if (this.hasConsented()) {
            //grantGoogleAnalytics();
            //grantReferCookie();
        }
    },
};
